// @ts-nocheck
/* eslint-enable */
import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';
import { zindex } from 'app/shared/styles/_zindex';
import { stacked } from 'app/shared/styles/_spacing';

export const Overlay = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding-left: 16px;
  padding-right: 16px;
  z-index: ${zindex['$z-index-loader']};
  background: ${colors['$hpx-white']};
  overflow: scroll;
`;

export const Header = styled.header`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  padding-left: 16px;
  padding-right: 16px;
  background: ${colors['$hpx-white']};
  z-index: ${zindex['$z-index-step-over']};
`;

export const Button = styled.button`
  background: none;
  color: ${colors['$hpx-teal-500']};
  padding-top: 16px;
  padding-bottom: 16px;
`;

export const ButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  ${stacked._2x};
`;

export const Section = styled.section`
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  padding-bottom: 16px;
`;

export const Article = styled.article`
  ${(props) =>
    props.paddingTop &&
    `
        padding-top: ${props.paddingTop}px;
    `}
`;
